<template>
  <v-card
    v-if="displayAlert"
    class="mt-4"
    style="border-left: 8px solid #ff9800; background: #fff3e0"
  >
    <v-row class="d-flex align-center">
      <v-col cols="12" sm="12" md="12" class="pl-1 pr-0 pr-md-3">
        <v-card-text class="pb-2 d-flex pt-2 pt-md-4">
          <v-icon color="orange" class="pa-2 mr-4 d-none d-md-flex">post_add </v-icon>
          <div class="d-flex justify-space-between flex-column" style="width: -webkit-fill-available;">
            <div class="d-flex justify-space-between align-center">
              <h1 class="text-subtitle-1 text-md-h6 font-weight-bold">
                Tenés ${{ amount }} pendientes de facturar
              </h1>
              <v-btn v-show="showCloseButton" @click="hideBillAlert()" icon
                ><v-icon>close</v-icon></v-btn
              >
            </div>
            <span
              class="text-subtitle-2 text-md-subtitle-1 grey--text text--darken-1"
            >
              Ahora podés hacer una factura para varios pedidos.
            </span>
            <div>
              <v-btn
                color="orange"
                class="custom-transform-class text-none px-0"
                text
                @click="$router.push('bill-form')"
                >Ir a facturar</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
const ROUTES = {
  INVOICES: "bill-list",
  REQUESTS: "request-list",
};
export default {
  name: "BillAlert",
  props: {
    showCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("invoice", {
      amount: (state) => state.totalAmountToInvoice,
      showAlert: (state) => state.showAlert,
    }),
    displayAlert() {
      if (this.$route.name === ROUTES.INVOICES) {
        return this.amount > 0;
      }

      if (this.$route.name === ROUTES.REQUESTS) {
        return this.showAlert && this.amount > 0;
      }

      return false;
    },
  },
  created() {
    this.getTotalAmount();
  },
  methods: {
    ...mapActions("invoice", ["getTotalAmount", "hideBillAlert"]),
  },
};
</script>

<style scoped>
.v-icon {
  background-color: var(--element-color);
}
</style>
